export default "__VITE_ASSET__DIW4mwPf__"